<template>
    <div class="gz-pagination">
        <div class="gz-pagination__nav-icon gz-pagination_back">
            <span class="icon-chevron-left"></span>
        </div>
        <div class="gz-pagination__items">
            <div
                v-for="(item, index) in 5"
                :key="index" 
                class="gz-pagination__item"
                :class="{'gz-pagination__item_active': !index}"><span>{{ item }}</span></div>
        </div>
        <div class="gz-pagination__nav-icon gz-pagination_foward">
            <span class="icon-chevron-right"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Pgination'
}
</script>